import { InputHTMLAttributes, forwardRef } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    hint?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ label, error, hint, className = '', id, ...props }, ref) => {
        const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
        return (
            <div className="w-full">
                {label && (
                    <label htmlFor={inputId} className="block text-sm font-semibold text-slate-700 mb-1.5">
                        {label}
                    </label>
                )}
                <input
                    ref={ref}
                    id={inputId}
                    className={`w-full px-4 py-2.5 rounded-lg border transition-all outline-none
                        ${error
                            ? 'border-red-400 bg-red-50 focus:ring-2 focus:ring-red-300 focus:border-red-400'
                            : 'border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                        }
                        disabled:bg-slate-100 disabled:text-slate-400 disabled:cursor-not-allowed
                        placeholder:text-slate-400 text-slate-900 text-sm
                        ${className}`}
                    {...props}
                />
                {hint && !error && <p className="mt-1.5 text-xs text-slate-500">{hint}</p>}
                {error && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
            </div>
        );
    }
);

Input.displayName = 'Input';
